<template>
  <div>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" v-for="(anosafraJob, index) in anosafraJobs">
        <a class="nav-link" 
          :class="{ active: activeTab === index }" 
          @click.prevent="changeTab(index)" 
          :href="`#${anosafraJob.anosafra.id}`" 
          role="tab" 
          aria-controls="home" 
          aria-selected="true"
        >
          {{ anosafraJob.anosafra.descricao }}
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div v-for="(anosafraJob, index) in anosafraJobs"
        class="tab-pane fade" 
        :class="{ show: activeTab === index, active: activeTab === index }"  
        :key="`pade_${anosafraJob.anosafra.id}`" 
        :id="anosafraJob.anosafra.id"
      >
        <div class="row justify-content-md-center px-4">
          <div class="col-12 form-group p-4">
            <collapse :multiple-active="false">
              <collapse-item v-for="(job, jobIndex) in anosafraJob.jobs" :key="jobIndex">
                <template v-slot:title>
                  <div>{{ jobTranslations[job] }}</div>
                </template>
                <div :id="wrapperId(anosafraJob.anosafra.id, jobIndex)">
                  <component 
                    :is="componentType(job)"
                    :value="componentValueHandler"
                    :anosafra="anosafraJob.anosafra"
                    :job="job"
                    :initialData="componentValueData(anosafraJob.anosafra.id, job)"
                    @input="handleInput(anosafraJob.anosafra.id, job, $event)"
                    @grow-container="growWrapperMargin(anosafraJob.anosafra.id, jobIndex)"
                    @shrink-container="shrinkWrapperMargin(anosafraJob.anosafra.id, jobIndex)"
                  />
                </div>
              </collapse-item>
            </collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, watch } from "vue";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import UserProductForm from '@/components/User/UserProductForm.vue';
import UserManagerForm from '@/components/User/UserManagerForm.vue';

const props = defineProps({
  anosafraJobs: { type: Array, required: true },
  initialData: { type: Array }
});

const emit = defineEmits(['update:valid', 'input']);
const activeTab = ref(0);
const changeTab = (index) => { activeTab.value = index }
const valid = ref(false);
const internalValue = ref({});
const jobTranslations = {
  grocery_manager: 'Gerente de Sementes HF',
  grain_manager: 'Gerente de Sementes Cereais',
  irrigation_manager: 'Gerente de Irrigação',
  nutrition_manager: 'Gerente de Nutrição',
  mkt_manager: 'Gerente de Negócios'
}

const isManagerDerivedJob = (job) => {
  return 'mkt_manager' == job
}

const wrapperId = (anosafraID, index) =>{
  return `job-association-form-wrapper-${anosafraID}-${index}`
}

const growWrapperMargin = (anosafraID, index) => {
  console.log("wrapperId(anosafraID, index): ", wrapperId(anosafraID, index))
  document.getElementById(wrapperId(anosafraID, index)).classList.add('grown-container');
}

const shrinkWrapperMargin = (anosafraID, index) => {
  console.log("wrapperId(anosafraID, index): ", wrapperId(anosafraID, index))
  document.getElementById(wrapperId(anosafraID, index)).classList.remove('grown-container');
}

const componentValueHandler = computed(() => {
  const currentAnosafraJob = props.anosafraJobs[activeTab.value];
  if (!currentAnosafraJob) return {};
  
  return internalValue.value[currentAnosafraJob.anosafra.id] || {};
})

const componentType = (job) => {
  if (isManagerDerivedJob(job)) return UserManagerForm;

  return UserProductForm;
}

const componentValueData = (anosafraID, job) => {
  if (!props.initialData) return {};
  console.log("props.initialData: ", props.initialData)
  let jobAssociation = props.initialData.find((el) => {
    console.log("el.anosafra.id: ", el.anosafra.id)
    console.log("anosafra.id: ", anosafraID)
    return el.anosafra.id == anosafraID
  });
  console.log("jobAssociation: ", jobAssociation)
  if (jobAssociation && jobAssociation.associations) jobAssociation = jobAssociation.associations.find(el => el.category == job);
  console.log("jobAssociation2: ", jobAssociation)
  if (!jobAssociation) return {};

  if (isManagerDerivedJob(job)) {
    return {
      managers: jobAssociation.managers,
      channels: jobAssociation.channels,
    }
  }

  return {
    brands: jobAssociation.brands,
    preferredproducts: jobAssociation.preferredproducts,
    grupos: jobAssociation.grupos,
    subgrupos: jobAssociation.subgrupos
  }
}

const handleInput = (anosafraId, job, value) => {
  updateInternalValue(anosafraId, job, value);
  validateData()
}

const updateInternalValue = (anosafraId, job, value) => {
  if (!internalValue.value[anosafraId]) internalValue.value[anosafraId] = {};

  const singularized_associations = {}

  Object.keys(value).forEach((key) => {
    singularized_associations[`${singularize(key)}_ids`] = value[key].map(el => el.id)
  })

  internalValue.value[anosafraId][job] = singularized_associations;
  emit('input', internalValue.value)
}

const singularize = (word) => {
  const endings = {
    ves: 'fe',
    ies: 'y',
    i: 'us',
    zes: 'ze',
    ses: 's',
    es: 'e',
    s: ''
  };

  return word.replace(
    new RegExp(`(${Object.keys(endings).join('|')})$`), 
    r => endings[r]
  );
}

const validateData = () => {
  const validData = props.anosafraJobs.every((anosafraJob) => {
    const anosafraID = anosafraJob.anosafra.id
    
    return anosafraJob.jobs.every((job) => {
      const jobAssociationsData = internalValue.value[anosafraID] && internalValue.value[anosafraID][job]

      if (!jobAssociationsData) return false;

      const jobAssociationsDataValues = Object.values(jobAssociationsData);

      if (job == 'mkt_manager') {
        // In mkt_manager it needs to fill 2 associations data: segment and managers
        return jobAssociationsDataValues.length == 2 &&
        jobAssociationsDataValues.every((associationData) => { 
          return associationData.length > 0
        })
      }

      return jobAssociationsDataValues.some((associationData) => associationData.length)
    })
  })

  valid.value = validData
}

watch(valid, (newVal, oldVal) => {
  if (oldVal == newVal) return;

  console.log("updating valid data: ", newVal)

  emit('update:valid', newVal)
}, { deep: true });


</script>

<style lang="css" scoped>
.grown-container {
  margin-bottom: 200px;
}
</style>